// import logo from "@/assets/dddiLogo.jpg";
// import InSvg from "@/assets/svg/InSvg";
// import Icon from "@ant-design/icons";
// import { useTranslation } from "react-i18next";
// import wx from "@/assets/img/wx.png";
import { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';

const Footer = () => {
  const aStyle = {
    color: '#333',
    textDecoration: "none"
  }
  // const { t, i18n } = useTranslation();
  const [showWX, showWXchange] = useState(false);
  const navigate = useNavigate();

  const handlePartnerClick = (e, url, anchor) => {
    e.preventDefault();
    navigate(url);
    setTimeout(() => {
      const element = document.getElementById(anchor);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <>
      <footer className="w-full" style={{ color: '#333', textAlign: 'left' }}>
        <div className="page-content a-hover-underline-list">
          <div className="lg:flex justify-between border-gray-500 py-10">
            <div className="lg:w-2/5 flex flex-col gap-5 mr-20">
              <div className="flex flex-col items-start mt-4 text-left text-lg font-bold" style={{ fontSize: "3rem" }}>
                <img src={'/logo.png'} alt="logo" style={{ width: "200px" }} />
              </div>
              {/* <div className="text-sm" style={{ fontSize: 15, paddingTop: 40 }}>
                <p>让数据驱动未来发展</p>
              </div> */}
            </div>
            <div className="lg:w-3/5 flex flex-col lg:flex-row text-sm mt-10 lg:mt-0">
              {/* Left Column */}
              <div className="flex flex-col space-y-8 lg:w-1/2">
                {/* 首页 */}
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">
                    <Link to="/" style={aStyle}>首页</Link>
                  </li>
                </ul>

                {/* 解决方案 */}
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">
                    <Link to="/solutions" style={aStyle}>解决方案</Link>
                  </li>
                </ul>

                {/* 跨境贸易&进出口管理 */}
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">综合类大数据与分析系统</li>
                  <li><Link to="/products/1" style={aStyle}>智源大数据洞察与分析平台</Link></li>
                  <li><Link to="/products/2" style={aStyle}>数极数据仓库与智能检索系统</Link></li>
                  <li><Link to="/products/3" style={aStyle}>思塔数据驱动业务洞察与策略优化平台</Link></li>
                  <li><Link to="/products/4" style={aStyle}>先见数据流与趋势预测引擎</Link></li>
                  <li><Link to="/products/5" style={aStyle}>合能数据整合与价值挖掘管理系统</Link></li>
                  <li><Link to="/products/6" style={aStyle}>精核数据质量监控与优化软件</Link></li>
                  {/* <li><Link to="/products/7" style={aStyle}>合约云国际贸易合同与文档电子化管理系统</Link></li>
                  <li><Link to="/products/8" style={aStyle}>贸智国际贸易流程自动化与智能优化平台</Link></li> */}
                </ul>
                {/* 海关报关，进出口申报 */}
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">房产市场洞察与投资分析系统</li>
                  <li><Link to="/products/re1" style={aStyle}>睿维房产市场动态监测与投资决策平台</Link></li>
                  <li><Link to="/products/re2" style={aStyle}>楼帷全球房产价值发现与挖掘系统</Link></li>
                  <li><Link to="/products/re3" style={aStyle}>领拓国际房产投资智能决策与策略管理平台</Link></li>
                  <li><Link to="/products/re4" style={aStyle}>固评房产项目筛选与综合风险评估系统</Link></li>
                </ul>
                {/* 研究领域 */}
               
{/* 
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl"><a
                    href="/newsroom"
                    style={aStyle}
                  >
                    新闻
                  </a></li>
                </ul>

                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">
                    <a href="/projects" style={aStyle}>项目</a>
                  </li>
                </ul> */}



                {/* 
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">{t('services')}</li>
                  <li><a
                    onClick={(e) => handlePartnerClick(e, '/group-members', 'cyberate-technologies')}
                    href="/group-members#cyberate-technologies" style={aStyle}>{t('forInvestors')}</a></li>
                  <li><a
                    onClick={(e) => handlePartnerClick(e, '/group-members', 'cyberate-technologies')}
                    href="/group-members#cyberate-technologies" style={aStyle}>{t('forIndividualBuyers')}</a></li>
                </ul> */}


                {/* <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">{t('footerCareers')}</li>
                  <li>
                    <a href="/careers" style={aStyle}>{t('applyNow')}</a>
                  </li>
                </ul> */}

                
              </div>

              {/* Right Column */}
              <div className="flex flex-col space-y-8 lg:w-1/2 mt-8 lg:mt-0">


                {/* 投资与风险管理 */}
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">投资与风险管理类系统</li>
                  <li><Link to="/products/inv1" style={aStyle}>智金投资项目筛选与风险评估系统</Link></li>
                  <li><Link to="/products/inv2" style={aStyle}>投策投资组合优化与智能调整工具</Link></li>
                </ul>

                {/* 股票& 证券 */}
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">数据可视化与展示类系统</li>
                  <li><Link to="/products/st1" style={aStyle}>观像数据可视化展示与智能洞察平台</Link></li>
                  <li><Link to="/products/st2" style={aStyle}>数渊数据展示与业务价值评估管理系统</Link></li>
                </ul>

                {/* 关于我们 */}
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">
                    <Link to="/about" style={aStyle}>关于我们</Link>
                  </li>
                </ul>

                {/* 联系我们 */}
                <ul className="flex flex-col space-y-2">
                  <li className="font-bold text-xl">
                    <Link to="/contact" style={aStyle}>联系我们</Link>
                  </li>
                </ul>

                {/* <ul className="flex gap-x-5">
                  <li>
                    <div className="flex flex-row items-center lg:items-end lg:ml-auto">
                      <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-blue-800 mx-4" >
                        <i className="fab fa-linkedin fa-2x "></i>
                      </a>
                      <div className="text-gray-500 hover:text-green-800 mx-4" style={{ position: "relative" }} onClick={() => showWXchange(!showWX)}>
                        <i className="fab fa-weixin fa-2x"></i>
                        {showWX && <div style={{ position: "absolute", top: "calc(-10rem - 60px)", left: "20px", width: "10rem", height: "5rem" }}>
                        </div>}
                      </div>
                      <a
                        href="https://www.xiaohongshu.com/user/profile/6642b1750000000007007702?xsec_token=&xsec_source=pc_search"
                        className="text-gray-500 hover:text-red-600 mx-4"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fas fa-book fa-2x"></i>
                      </a>
                      <div
                        className="text-gray-500 hover:text-yellow-600 mx-4"
                        onClick={() => { window.location.href = 'mailto:info@dddi.com.au' }}
                      >
                        <i className="fas fa-envelope fa-2x"></i>
                      </div>
                    </div>
                  </li>
                </ul> */}

              </div>
            </div>
          </div>

          <div className="py-10 text-sm flex flex-col lg:flex-row justify-between items-center">
            {/* <ul className="flex gap-x-5">
              <li>
                <div className="flex flex-row items-center lg:flex-col lg:items-end lg:ml-auto">
                  <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-100 hover:text-blue-800 mx-4" >
                    <i className="fab fa-linkedin fa-2x "></i>
                  </a>
                  <div className="text-gray-100 hover:text-green-800 mx-4" style={{ position: "relative" }} onClick={() => showWXchange(!showWX)}>
                    <i className="fab fa-weixin fa-2x"></i>
                    {showWX && <div style={{ position: "absolute", top: "calc(-10rem - 60px)", left: "20px", width: "10rem", height: "5rem" }}>
                      <img src={wx}></img>
                    </div>}
                  </div>
                  <a
                    href="https://www.xiaohongshu.com/user/profile/6642b1750000000007007702?xsec_token=&xsec_source=pc_search"
                    className="text-gray-100 hover:text-red-600 mx-4"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fas fa-book fa-2x"></i>
                  </a>
                  <div
                    className="text-gray-100 hover:text-yellow-600 mx-4"
                    onClick={() => { window.location.href = 'mailto:info@dddi.com.au' }}
                  >
                    <i className="fas fa-envelope fa-2x"></i>
                  </div>
                </div>
              </li>
            </ul> */}
          </div>

          <p className="text-xs pb-8 text-center lg:text-left">
            版权所有 © 2024 河北视动科技有限公司. 保留所有权利。冀ICP备2025107455号-1<span style={{ float: 'right' }}>v1.0.2</span>
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
